import useNavigation from './useNavigation';

interface IParams {
  project_id?: string;
}

export default function useBudgetReportDetailsNavigation() {
  return useNavigation<IParams>('/budget-report-details');
}
